import { DEFAULT_PERMISSIONS } from './AuthConstants'
import jwt_decode from 'jwt-decode'

class AuthService {
  storeAuthToken(authToken: string): void {
    window.localStorage.setItem('authToken', authToken)
  }

  getAuthToken(): string {
    return window.localStorage.getItem('authToken') || ''
  }

  getAuthTokenHeader(): string {
    return 'Bearer ' + this.getAuthToken()
  }

  isAuthenticated(): boolean {
    return this.getAuthToken().length > 0
  }

  isTokenExpired(jwtToken: string): boolean {
    if (jwtToken) {
      const decodedToken: any = jwt_decode(jwtToken)
      const current_time = new Date().getTime() / 1000
      return current_time > decodedToken.exp
    }
    return false
  }

  getLoggedinUser(jwtToken: string) {
    const decodedToken: any = jwt_decode(jwtToken)
    return decodedToken.sub
  }

  removeAuthToken(): void {
    window.localStorage.removeItem('authToken')
  }

  storeUserDetails(userDetails: any) {
    window.localStorage.setItem('needsPasswordChange', userDetails.needsPasswordChange.toString())
    window.localStorage.setItem('isAdUser', userDetails.adUser.toString())
    window.localStorage.setItem('permissions', userDetails.permissions.toString())
  }

  removeUserDetails(): void {
    localStorage.removeItem('needsPasswordChange')
    localStorage.removeItem('isAdUser')
    localStorage.removeItem('permissions')
  }

  getNeedsPasswordChange(): boolean {
    return window.localStorage.getItem('needsPasswordChange') === 'true'
  }

  getIsAdUser(): boolean {
    return window.localStorage.getItem('isAdUser') === 'true'
  }

  getPermissions(): Array<string> {
    const permissions = window.localStorage.getItem('permissions')
    return permissions ? permissions.split(',') : DEFAULT_PERMISSIONS
  }

  hasPermission(userPermission: string[], accessPermission: string[]): boolean {
    return accessPermission.includes('*') || userPermission.some((e) => accessPermission.indexOf(e) !== -1)
  }
}

export default new AuthService()
